import React, { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import * as Toast from '../../lib/Toast.js';
import {
    setBusinessInfo,
    useBusinessInfo,
    useUserInfoQuery,
} from '../../lib/Queries';
import TimezoneSelect from '../TimezoneSelect.jsx';
import { getBrowserTimezone } from '../../lib/DateTime.js';
import Loading from '../Loading';
import Select from '~/components/Select';
import OptionToggle from '~/components/OptionToggle.jsx';

const DateTimeSettings = () => {
    const { isLoading, data, refetch } = useBusinessInfo();
    const { business } = data || {};
    const { refetch: refetchUserInfo } = useUserInfoQuery();

    const [timezone, setTimezone] = useState('');
    const [weekStart, setWeekStart] = useState(1);
    const [use24HourTime, setUse24HourTime] = useState(false);
    const [fixedTimezone, setFixedTimezone] = useState(false);

    const { isSaving, save } = useBusinessPostApi(`/update-datetime-settings`);

    useEffect(() => {
        if (business) {
            setTimezone(business.timezone);
            setWeekStart(business.week_start);
            setUse24HourTime(!!business.use_24_hour_time);
            setFixedTimezone(!!business.fixed_timezone);
        }
    }, [JSON.stringify(business)]);

    function submit(ev) {
        ev.preventDefault();

        save({
            timezone: timezone,
            week_start: weekStart,
            use_24_hour_time: use24HourTime,
            fixed_timezone: fixedTimezone,
        }).then(() => {
            Toast.success('Successfully saved');
            refetchUserInfo();
            refetch();
        });
    }

    return (
        <div>
            {(isLoading || !business) && <Loading />}
            {!(isLoading || !business) && (
                <form onSubmit={submit} className="">
                    <div className="mb-4">
                        <TimezoneSelect
                            id="timezone"
                            label="Time Zone"
                            inputClassName="w-full max-w-lg"
                            value={timezone}
                            onChange={setTimezone}
                        />
                        {!!timezone && getBrowserTimezone() !== timezone && (
                            <div className="text-yellow-600 mt-1">
                                This time zone selected ({timezone}) is
                                different than your browser (
                                {getBrowserTimezone()}).
                            </div>
                        )}
                    </div>

                    <Select
                        label="Week Starts On"
                        value={weekStart}
                        onChange={setWeekStart}
                        options={{
                            1: 'Monday',
                            0: 'Sunday',
                        }}
                        className="mb-4"
                    />

                    <OptionToggle
                        value={use24HourTime}
                        onChange={setUse24HourTime}
                        toggleFirst={true}
                        title="Use 24 Hour Time"
                        description="Show times in 24 hour format instead of 12 hour with AM/PM"
                        className="max-w-lg mb-4"
                    />

                    <OptionToggle
                        value={fixedTimezone}
                        onChange={setFixedTimezone}
                        toggleFirst={true}
                        title="Always book in business time zone"
                        description={
                            <div>
                                Instead of clients seeing times in their time
                                zone, they will always see times in the
                                business's time zone ({timezone}).
                                {fixedTimezone && (
                                    <div>
                                        (If admin users are logged in they will
                                        still see the calendar and all times in
                                        their time zone)
                                    </div>
                                )}
                            </div>
                        }
                        className="max-w-lg mb-6"
                    />

                    <div className="flex flex-wrap items-center justify-between max-w-lg gap-2">
                        <button type="submit" className="btn-save w-full xs:w-auto">
                            {isSaving ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default DateTimeSettings;

